import selectGameCard from './game-card';

const selectGameCards = (phrases, games) => games.map(
  game => selectGameCard(phrases, game),
);

export default selectGameCards;
